import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import api from "../Services/api";
import { app_base_url, app_server, base_url_enderecos_api } from "../Utils/baseUrl";
import { prefeituraKey, prefeituratokenKey } from "../Utils/localStorageKeys";
import { useCartorio } from "./cartorio";
import { useFuncionarioPrefeitura } from "./funcionarioPrefeitura";
export interface IPrefeitura {
  ID: number;
  NOME: string;
  STATUS: string;
  LIGACAO_ID: number;
  SENHA?: string;
  
}

export interface IPrefeituraAssets {
  id: number;
  logo: string;
}

interface IPrefeituraContextData {
  getPrefeituras(cartorio_id?: number): Promise<void>;
  prefeituras: IPrefeitura[];
  assets: IPrefeituraAssets[];
  handleAddPrefeitura(ant_ligacao: IPrefeitura, n_ligacao: IPrefeitura): void;
  signInPrefeitura(nome: string, senha: string): Promise<void>;
  prefeitura: IPrefeitura;
  prefeituraIsLogged: boolean;
  checarTokenPrefeitura(): Promise<void>;
  handleSetPrefeitura(pref: IPrefeitura): void;
  signOutPrefeitura(): void;
  logoPrefeitura:string;
  bancoPrefeitura:string;
  prefeiturasNaoLigadas:IPrefeitura[];
  getPrefeituraById(id:number):Promise<void>;
  helpSignInHashPrefeitura():void;
  carregaLogo(id?:number):void;
}

interface IPrefeituraProviderProps {
  children: ReactNode;
}

const PrefeituraContext = createContext({} as IPrefeituraContextData);

function PrefeituraProvider({ children }: IPrefeituraProviderProps) {

  const{funcionarioPrefeituraIsLogged} = useFuncionarioPrefeitura();

  const [prefeituraIsLogged, setPrefeituraIsLogged] = useState(false);
  const [prefeitura, setPrefeitura] = useState({} as IPrefeitura);
  const[prefeiturasNaoLigadas,setPrefeiturasNaoLigadas]= useState([] as IPrefeitura[]);

  const [prefeituras, setPrefeituras] = useState([] as IPrefeitura[]);
  const [assets, setAssets] = useState({} as IPrefeituraAssets[]);
  const { cartorio } = useCartorio();
  const[logoPrefeitura,setLogoPrefeitrua] = useState("");
  const[bancoPrefeitura, setBancoPrefeitura] = useState("");

  
  async function signInPrefeitura(nome: string, senha: string) {
    try {
      const { data } = await api.post(`/prefeitura/signIn`, { nome, senha });
      console.log(data);
      setPrefeitura(data.prefeitura);
      
      setPrefeituraIsLogged(true);
      localStorage.setItem(prefeituraKey, JSON.stringify(data.prefeitura));
      localStorage.setItem(prefeituratokenKey, data.token);
      api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    } catch (error) {
      throw error;
    }
  }

  useEffect(() => {
    if(!funcionarioPrefeituraIsLogged && !prefeituraIsLogged){
      setPrefeitura({} as IPrefeitura)
    }
  }, [funcionarioPrefeituraIsLogged]);


  async function getPrefeituraById(id:number){
    try {
      const { data } = await api.get(`/prefeitura/${id}`);
      console.log(data);
      setPrefeitura(data);
      
     
    
    } catch (error) {
      throw error;
    }
  }

  async function getPrefeituras(cartorio_id?: number) {
    try {
      const { data } = await api.get<IPrefeitura[]>(
        `/ligacao/by_cartorio/${cartorio.ID}`
      );
     
      const todas_prefeituras = await api.get<IPrefeitura[]>(
        `/prefeitura`
      );

      setPrefeiturasNaoLigadas(todas_prefeituras.data);
      setPrefeituras(data);
      const teste = await axios.get<IPrefeituraAssets[]>(
        `https://solucoes.sinsoft.com.br/api/enderecos/`
      );
       
      setAssets(teste.data);
     
    } catch (error) {
      throw error;
    }
  }

  function handleAddPrefeitura(
    ant_ligacao: IPrefeitura,
    n_ligacao: IPrefeitura
  ) {
    const posicao = prefeituras.indexOf(ant_ligacao);
    const update = prefeituras.splice(posicao, 1, n_ligacao);
    setPrefeituras(prefeituras);
  }

  async function checarTokenPrefeitura() {
    try {
      const token = localStorage.getItem(prefeituratokenKey);
      const prefeitura = localStorage.getItem(prefeituraKey);

      if (token && prefeitura != null) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        await api.get("/checa-token");
        setPrefeitura(JSON.parse(prefeitura));
        setPrefeituraIsLogged(true);
      }
    } catch (error) {
      //Se estiver invalido o token eu valido ele
      if (prefeitura) {
        signInSenhaHash();
      }else
      throw "Token Inválido!";
    }
  }

  async function signInSenhaHash() {
    const getPrefeitura = localStorage.getItem(prefeituraKey);
    if (getPrefeitura != null) {
      setPrefeitura(JSON.parse(getPrefeitura));
      if (prefeitura) {
        //window.alert(funcionarioCartorio.ID + " " +funcionarioCartorio.SENHA )
        try {
          const { data } = await api.post(`/prefeitura/signInHash`, {
            nome: prefeitura.NOME,
            senha: prefeitura.SENHA,
          });

          api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
          setPrefeitura(data.funcionario);
          setPrefeituraIsLogged(true);
        } catch (error) {
          signOutPrefeitura();
          throw error;
        }
      }
    }
  }

  function handleSetPrefeitura(pref: IPrefeitura) {
    setPrefeitura(pref);
    localStorage.setItem(prefeituraKey, JSON.stringify(prefeitura));
  }

  function signOutPrefeitura() {
    setPrefeitura({} as IPrefeitura);
    localStorage.removeItem(prefeituratokenKey);
    localStorage.removeItem(prefeituraKey);
    setPrefeituraIsLogged(false);
    window.location.href = `${app_server}${app_base_url}/prefeitura`;
  }

  useEffect(() => {
    checarTokenPrefeitura();
  }, []);

 async function carregaLogo(id?: number){
    try {
      
      const {data} = await axios.get(`${base_url_enderecos_api}/id/${id?id:prefeitura.ID}`);
      setLogoPrefeitrua(data.logo);
      setBancoPrefeitura(data.banco);
    
    
    } catch (error) {
      throw error;
    }
 }

  useEffect(() => {
   
      
      carregaLogo();
    
  },[prefeitura.ID])
  function helpSignInHashPrefeitura(){
    signInSenhaHash();
  }

  return (
    <PrefeituraContext.Provider
      value={{
        bancoPrefeitura,
        signInPrefeitura,
        prefeitura,
        prefeituraIsLogged,
        getPrefeituras,
        helpSignInHashPrefeitura,
        prefeituras,
        assets,
        handleAddPrefeitura,
        checarTokenPrefeitura,
        handleSetPrefeitura,
        signOutPrefeitura,
        logoPrefeitura,
        prefeiturasNaoLigadas,
        getPrefeituraById,
        carregaLogo
      }}
    >
      <>{children}</>
    </PrefeituraContext.Provider>
  );
}

function usePrefeitura() {
  const context = useContext(PrefeituraContext);

  return context;
}

export { PrefeituraProvider, usePrefeitura };
